/* Decision 7180: the note window's Rich text switch, its label and the hint beneath it; the window's one hint style, which Also about reads too. */
.richRow {
  display: grid;
  gap: var(--space-1);
}

.richSwitch {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.richLabel {
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}

.hint {
  margin: 0;
  font-size: var(--font-size-caption);
  color: var(--text-muted);
}
